import { render, staticRenderFns } from "./EditMaterialVariant.vue?vue&type=template&id=c0bc94d8&scoped=true"
import script from "./EditMaterialVariant.vue?vue&type=script&lang=js"
export * from "./EditMaterialVariant.vue?vue&type=script&lang=js"
import style0 from "./EditMaterialVariant.vue?vue&type=style&index=0&id=c0bc94d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bc94d8",
  null
  
)

export default component.exports